export default {
  independentMarketing: {
    common: {
      requestFailed: 'Запрос интерфейса не удался',
      hintSelect: 'Выбирать',
      hintInput: 'Входить',
      submit: 'Представлять на рассмотрение',
      cancel: 'Отмена',
      confirm: 'Определение',
    },
    agreement: {
      title: 'Соглашение о регистрации независимого дилера Autel',
      nextBtn: 'Следующий',
      getAgreementFailed: 'Не удалось получить содержимое соглашения.',
    },
    successPage: {
      title:
        'Информация о вашей заявке была успешно отправлена, и результаты рассмотрения будут отправлены на ваш адрес электронной почты $1 в течение 15 рабочих дней. Пожалуйста, проверьте свой почтовый ящик для получения дополнительной информации.',
      subTitle: 'Вернитесь на домашнюю страницу через $1 секунд.',
    },
    applyTitle:
      'Вы подаете заявку на то, чтобы стать независимым дилером Autel. Пожалуйста, точно заполните следующую информацию:',
    companyName: 'Название компании',
    companyTax: 'VAT ID',
    userCountry: 'Страна',
    legalPerson: 'Юрисконсульт',
    contactEmail: 'Почта для связи',
    contactEmailTips:
      'Этот адрес электронной почты будет вашим контактным письмом с результатами проверки. Как только отзыв будет одобрен, он также будет использоваться в качестве имени учетной записи для входа в систему управления независимыми дилерами.',
    corporateIdentity: 'Идентификатор юрисконсульта',
    uploadTips: 'JPG, JPEG, PNG, PDF (не более 20 MB)',
    businessLicense: 'Бизнес-лицензия',
    emailErrorTips: 'Введите действительный адрес электронной почты.',
    uploadPic: 'Загрузить изображения',
    picMaxLimit: 'Максимальный размер изображения - 20 MB. Пожалуйста, выберите еще раз.',
  },
};
